'use strict'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import MergeDropdownComponent from '../commonComponents/MergeDropdownComponent';
import TableComponent from '../commonComponents/TableComponent';
import TableParent from '../commonComponents/TableParent';
import LoadingComponent from '../commonComponents/LoadingComponent';
import { connect } from 'react-redux';
import BootstrapTable from '../commonComponents/BootstrapTable';
import { ButtonComponent } from '../../../src/components/commonComponents/UIComponent';
import TagsComponent from '../commonComponents/TagsComponent';


var test_tables = [
    {
        "name": "First Retail Transaction",
        "value": "customer_200.first_retail_transaction",
        "subtext_value": "transaction",
        "columnConfig": [
            {
                "name": "customer_id",
                "value": "customer_id",
                "type": "transaction",
                "tableValue": "customer_200.first_retail_transaction",
                "subtext_value": "First Retail Transaction",
                "id": "First Retail Transaction_customer_id",
                "tag_name": "(First Retail Transaction)customer_id",
                "label": "customer_id"
            },
            {
                "name": "trans_date",
                "value": "trans_date",
                "type": "transaction",
                "tableValue": "customer_200.first_retail_transaction",
                "subtext_value": "First Retail Transaction",
                "id": "First Retail Transaction_trans_date",
                "tag_name": "(First Retail Transaction)trans_date",
                "label": "trans_date"

            }
        ],
        "includedColumns": [
            {
                "name": "customer_id",
                "value": "customer_id",
                "type": "transaction",
                "tableValue": "customer_200.first_retail_transaction",
                "subtext_value": "First Retail Transaction",
                "id": "First Retail Transaction_customer_id",
                "tag_name": "(First Retail Transaction)customer_id",
                "label": "customer_id"
            },
            {
                "name": "trans_date",
                "value": "trans_date",
                "type": "transaction",
                "tableValue": "customer_200.first_retail_transaction",
                "subtext_value": "First Retail Transaction",
                "id": "First Retail Transaction_trans_date",
                "tag_name": "(First Retail Transaction)trans_date",
                "label": "trans_date"
            }
        ]
    },
    {
        "name": "Retail Dataset", "value": "customer_200.retail_dataset", "subtext_value": "transaction", "columnConfig": [{ "name": "customer_id", "value": "customer_id", "type": "Merge", "tableValue": "customer_200.retail_dataset", "subtext_value": "Retail Dataset", "id": "Retail Dataset_customer_id", "tag_name": "(Retail Dataset)customer_id", "label": "customer_id" }, { "name": "trans_date", "value": "trans_date", "type": "Merge", "tableValue": "customer_200.retail_dataset", "subtext_value": "Retail Dataset", "id": "Retail Dataset_trans_date", "tag_name": "(Retail Dataset)trans_date", "label": "trans_date" }, { "name": "tran_amount", "value": "tran_amount", "type": "Merge", "tableValue": "customer_200.retail_dataset", "subtext_value": "Retail Dataset", "id": "Retail Dataset_tran_amount", "tag_name": "(Retail Dataset)tran_amount", "label": "tran_amount" }], "includedColumns": [{ "name": "customer_id", "value": "customer_id", "type": "Merge", "tableValue": "customer_200.retail_dataset", "subtext_value": "Retail Dataset", "id": "Retail Dataset_customer_id", "tag_name": "(Retail Dataset)customer_id", "label": "customer_id" }, { "name": "trans_date", "value": "trans_date", "type": "Merge", "tableValue": "customer_200.retail_dataset", "subtext_value": "Retail Dataset", "id": "Retail Dataset_trans_date", "tag_name": "(Retail Dataset)trans_date", "label": "trans_date" }, {
            "name": "tran_amount", "value": "tran_amount", "type": "Merge", "tableValue": "customer_200.retail_dataset", "subtext_value": "Retail Dataset", "id": "Retail Dataset_tran_amount", "tag_name": "(Retail Dataset)tran_amount", "label": "tran_amount"
        }]
    },

    {
        "name": "Cricket Delivery Data", "value": "customer_200.cricket_delivery_data", "subtext_value": "transaction",
        "columnConfig": [
            { "name": "match_id", "value": "match_id", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_match_id", "tag_name": "(Cricket Delivery Data)match_id" },
            { "name": "inning", "value": "inning", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_inning", "tag_name": "(Cricket Delivery Data)inning" },
            { "name": "batting_team", "value": "batting_team", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_batting_team", "tag_name": "(Cricket Delivery Data)batting_team" }, { "name": "bowling_team", "value": "bowling_team", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_bowling_team", "tag_name": "(Cricket Delivery Data)bowling_team" }, { "name": "over", "value": "over", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_over", "tag_name": "(Cricket Delivery Data)over" }, { "name": "ball", "value": "ball", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_ball", "tag_name": "(Cricket Delivery Data)ball" }, { "name": "batsman", "value": "batsman", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_batsman", "tag_name": "(Cricket Delivery Data)batsman" }, { "name": "non_striker", "value": "non_striker", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_non_striker", "tag_name": "(Cricket Delivery Data)non_striker" }, { "name": "bowler", "value": "bowler", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_bowler", "tag_name": "(Cricket Delivery Data)bowler" }, { "name": "is_super_over", "value": "is_super_over", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_is_super_over", "tag_name": "(Cricket Delivery Data)is_super_over" }, { "name": "wide_runs", "value": "wide_runs", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_wide_runs", "tag_name": "(Cricket Delivery Data)wide_runs" }, { "name": "bye_runs", "value": "bye_runs", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_bye_runs", "tag_name": "(Cricket Delivery Data)bye_runs" }, { "name": "legbye_runs", "value": "legbye_runs", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_legbye_runs", "tag_name": "(Cricket Delivery Data)legbye_runs" }, { "name": "noball_runs", "value": "noball_runs", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_noball_runs", "tag_name": "(Cricket Delivery Data)noball_runs" }, { "name": "penalty_runs", "value": "penalty_runs", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_penalty_runs", "tag_name": "(Cricket Delivery Data)penalty_runs" }, { "name": "batsman_runs", "value": "batsman_runs", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_batsman_runs", "tag_name": "(Cricket Delivery Data)batsman_runs" }, { "name": "extra_runs", "value": "extra_runs", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_extra_runs", "tag_name": "(Cricket Delivery Data)extra_runs" }, { "name": "total_runs", "value": "total_runs", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_total_runs", "tag_name": "(Cricket Delivery Data)total_runs" }, { "name": "player_dismissed", "value": "player_dismissed", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_player_dismissed", "tag_name": "(Cricket Delivery Data)player_dismissed" }, { "name": "dismissal_kind", "value": "dismissal_kind", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_dismissal_kind", "tag_name": "(Cricket Delivery Data)dismissal_kind" }, { "name": "fielder", "value": "fielder", "type": "transaction", "tableValue": "customer_200.cricket_delivery_data", "subtext_value": "Cricket Delivery Data", "id": "Cricket Delivery Data_fielder", "tag_name": "(Cricket Delivery Data)fielder" }]
    }
];

var addToFinalTable = "Add to Final Table" 


class StepThree extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            selectedTransactionTable: [],
            final_table: [],
            base_index:null,
            mapping:{
                "newKeys":{}
            }
        }        

        this.nextAction = this.nextAction.bind(this);
        this.backAction = this.backAction.bind(this);
        this.handlePrimaryTransaction = this.handlePrimaryTransaction.bind(this);
        // this.generateTableBodyConfig = this.generateTableBodyConfig.bind(this);
        this.generateTableBodyRows = this.generateTableBodyRows.bind(this);
        this.generateTableHeader = this.generateTableHeader.bind(this);
        this.handleTableMapping = this.handleTableMapping.bind(this);
        this.generateFinalBody = this.generateFinalBody.bind(this);
    }

    componentDidUpdate(){       
        if (this.state.selectedTransactionTable.length !== 0) {
            if (jQuery(`#${this.state.selectedTransactionTable.value}_data`).length) {
                 jQuery(`#${this.state.selectedTransactionTable.value}_data`).remove() 
            }
        }
    }

    componentWillMount() {
        let transaction_table_array = this.props.stepData.fetchIncludedColumns(this.props.stepData.state.selectedTable.transaction);                
        // let transaction_table_array = this.props.stepData.fetchIncludedColumns(test_tables); // Dummy tables
        this.setState({transaction_table_array: transaction_table_array})
    }

    backAction() {
        this.props.stepData.handleBackTrack(this);
    }
    nextAction(e) {
        if (e.target.id == "nextButton") {
            if (Object.keys(this.state.mapping).length === 1 && this.state.final_table.length === 0) {
                this.state.transaction_table_array.length === 1
                    ? alert("Please map selected Transaction table columns")
                    : alert("Please map selected Transaction tables columns");
            } else {
                if (Object.keys(this.state.mapping).length <= this.state.transaction_table_array.length) {
                    this.state.transaction_table_array.length === 1
                        ? alert("Please complete the mapping of selected Transaction table")
                        : alert("Please complete the mapping of selected Transaction tables")
                } else {
                    this.props.stepData.handleSteps(this);
                }
            }
        }
    }

    handlePrimaryTransaction(e, reference) {
        let selected_table = [];
        let base_index = this.state.base_index;
        let mapOptions =  [
            {"name": addToFinalTable, "value": "new"}
        ];

        let final_table_state = this.state.final_table;

        base_index = reference.props.dropdownConfig.dropdownData.findIndex((innerData, i) => {
            return e.target.value == innerData.value;
        })

        let map_config = [];
        //if (final_table_state.length === 0 && base_index === 0){
        if (final_table_state.length == 0){
            map_config = [...mapOptions];
        } else {
            map_config = [...mapOptions, ...final_table_state];
        }

        selected_table = reference.props.dropdownConfig.dropdownData[base_index];

        var allColumns = Object.values(selected_table.columnConfig)
        allColumns = allColumns.map(value => value['name'])

        let headerMapper = this.generateTableHeader("mapper", selected_table, map_config);
        let headerResult = this.generateTableHeader("result", selected_table, map_config);

        if(e.target.id == "transaction_table"){
            this.setState({
                selectedTransactionTable: selected_table,
                mapOptions: map_config,
                allColumns: allColumns,
                headerMapper: headerMapper,
                headerResult: headerResult,
                base_index: base_index,
            }, () => {
                if(Object.keys(this.state.mapping).indexOf(selected_table.value) === -1) {
                    this.handleTableMapping(undefined, null)
                }
            });
        }
    }

    handleTableMapping(e,reference=null){
        let appendData = {
            "mapping": null,
            "final_table": null
        }
        let targetValue = null;
        let mapping = this.state.mapping;
        let innerState = this.state.final_table;
        let stepMapping = this.props.stepData.state.stepMapping;
        let column_key = null;
        let innerArray = [];
        if (e === undefined && this.state.base_index === 0) {
            targetValue = "new";
            this.state.allColumns.forEach((element, index) => {
                targetValue = "new";
                innerArray = this.state.selectedTransactionTable['columnConfig'][index];
                if (innerArray['tempSubtext'] == null || innerArray['tempSubtext'] == undefined) {
                    innerArray.tempSubtext = innerArray.subtext_value;
                    innerArray.subtext_value = this.props.stepData.state.selectedTable.master.length === 0 ? innerArray.subtext_value : "Intermediate Transaction Table";
                }
                column_key = `${innerArray['subtext_value']}.${innerArray['name']}`;
                if (mapping[this.state.selectedTransactionTable['value']] == null || mapping[this.state.selectedTransactionTable['value']] == undefined) {
                    mapping[this.state.selectedTransactionTable['value']] = {};
                }
                mapping[this.state.selectedTransactionTable['value']][innerArray['value']] = targetValue;
                if (stepMapping[this.state.selectedTransactionTable['value']] == null || stepMapping[this.state.selectedTransactionTable['value']] == undefined) {
                    stepMapping[this.state.selectedTransactionTable['value']] = {};
                }
                stepMapping[this.state.selectedTransactionTable['value']][innerArray['value']] = innerArray['value'];
                if (mapping.newKeys[column_key] == null || mapping.newKeys[column_key] == undefined) {
                    mapping.newKeys[column_key] = innerState.length;
                    innerState.push(innerArray);
                } 
            });
            appendData.mapping = stepMapping;
            appendData.final_table = innerState;
            this.setState({
                final_table: innerState,
                mapping: mapping
            })
        } else if (e === undefined && this.state.base_index >= 1 && Object.keys(this.state.mapping).indexOf(this.state.transaction_table_array[0].value) !== -1) {
            let final_selected_config = [];
            this.state.allColumns.forEach((element, index) => {
                let number = this.state.final_table.findIndex(el => el.value === element);
                innerArray = this.state.selectedTransactionTable['columnConfig'][index];
                if (innerArray['tempSubtext'] == null || innerArray['tempSubtext'] == undefined) {
                    innerArray.tempSubtext = innerArray.subtext_value;
                    innerArray.subtext_value = this.props.stepData.state.selectedTable.master.length === 0 ? innerArray.subtext_value : "Intermediate Transaction Table";
                }
                if (mapping[this.state.selectedTransactionTable['value']] == null || mapping[this.state.selectedTransactionTable['value']] == undefined) {
                    mapping[this.state.selectedTransactionTable['value']] = {};
                }
                if (stepMapping[this.state.selectedTransactionTable['value']] == null || stepMapping[this.state.selectedTransactionTable['value']] == undefined) {
                    stepMapping[this.state.selectedTransactionTable['value']] = {};
                }
                stepMapping[this.state.selectedTransactionTable['value']][innerArray['value']] = innerArray['value'];
                if (number > -1) {
                    targetValue = element;
                    column_key = `${innerArray['tempSubtext']}.${innerArray['name']}`;
                    mapping[this.state.selectedTransactionTable['value']][innerArray['value']] = targetValue;
                    if (mapping.newKeys[column_key] !== null && mapping.newKeys[column_key] !== undefined) {
                        innerState.splice(mapping.newKeys[column_key], 1);
                    }
                    final_selected_config = innerState.map((element, i) => {
                        if (element.map !== undefined && element.map !== null) {
                            if (element['map'][column_key] !== undefined && element['map'][column_key] !== null) {
                                if (element.value !== targetValue) {
                                    delete element['map'][column_key]
                                }
                            }
                        }
                        if (element.value == targetValue) {
                            if (element.map == null || element.map == undefined) {
                                element.map = {};
                            }
                            element.map[column_key] = [innerArray];
                        }
                        return element;
                    });
                    appendData.mapping = stepMapping;
                    appendData.final_table = final_selected_config;
                    this.setState({
                        mapping: mapping,
                        final_table: final_selected_config
                    })
                } else {
                    targetValue = "new";
                    column_key = `${innerArray['subtext_value']}.${innerArray['name']}`;
                    mapping[this.state.selectedTransactionTable['value']][innerArray['value']] = targetValue;
                    if (mapping.newKeys[column_key] == null || mapping.newKeys[column_key] == undefined) {
                        mapping.newKeys[column_key] = innerState.length;
                        innerState.push(innerArray);
                    }
                    appendData.mapping = stepMapping;
                    appendData.final_table = innerState;
                    this.setState({
                        final_table: innerState,
                        mapping: mapping
                    })
                }
            });
        } else if (e !== undefined) {
            targetValue = e;
            targetValue = targetValue.value ? targetValue.value : e.target.value;
            targetValue = targetValue == addToFinalTable ? "new" : targetValue

            let rowIndex = null
            if (reference) {
                rowIndex = reference.props.rowIndex
            } else {
                rowIndex = this.state.allColumns.indexOf(e.data.transaction)
            }
            innerArray = this.state.selectedTransactionTable['columnConfig'][rowIndex];
            if (innerArray['tempSubtext'] == null || innerArray['tempSubtext'] == undefined) {
                innerArray.tempSubtext = innerArray.subtext_value;
                innerArray.subtext_value = this.props.stepData.state.selectedTable.master.length === 0 ? innerArray.subtext_value : "Intermediate Transaction Table";
            }
            if (targetValue == "new") {
                column_key = `${innerArray['subtext_value']}.${innerArray['name']}`;
            } else {
                column_key = `${innerArray['tempSubtext']}.${innerArray['name']}`;
            }
            if (mapping[this.state.selectedTransactionTable['value']] == null || mapping[this.state.selectedTransactionTable['value']] == undefined) {
                mapping[this.state.selectedTransactionTable['value']] = {};
            }
            mapping[this.state.selectedTransactionTable['value']][innerArray['value']] = targetValue;
            if (stepMapping[this.state.selectedTransactionTable['value']] == null || stepMapping[this.state.selectedTransactionTable['value']] == undefined) {
                stepMapping[this.state.selectedTransactionTable['value']] = {};
            }
            stepMapping[this.state.selectedTransactionTable['value']][innerArray['value']] = innerArray['value'];
            appendData.mapping = stepMapping;
            if (targetValue == "new") {
                if (mapping.newKeys[column_key] == null || mapping.newKeys[column_key] == undefined) {
                    mapping.newKeys[column_key] = innerState.length;
                    innerState.push(innerArray);
                }
                appendData.final_table = innerState;
                this.setState({
                    final_table: innerState,
                    mapping: mapping
                })
            } else {
                if (mapping.newKeys[column_key] !== null && mapping.newKeys[column_key] !== undefined) {
                    innerState.splice(mapping.newKeys[column_key], 1);
                }
                let final_selected_config = innerState.map((element, i) => {
                    if (element.map !== undefined && element.map !== null) {
                        if (element['map'][column_key] !== undefined && element['map'][column_key] !== null) {
                            if (element.value !== targetValue) {
                                delete element['map'][column_key]
                            }
                        }
                    }

                    if (element.value == targetValue) {
                        if (element.map == null || element.map == undefined) {
                            element.map = {};
                        }
                        element.map[column_key] = [innerArray];
                    }

                    return element;
                });
                appendData.final_table = final_selected_config;
                this.setState({
                    mapping: mapping,
                    final_table: final_selected_config
                })
            }
        }
        if (appendData.final_table !== null && appendData.mapping !== null) {
            this.props.stepData.handleAppendTable(appendData);
        }
    }

    generateTableHeader(type, selectedTransactionTable=null, map_config=[]){
        // let map_config_values = Object.values(map_config_values).map(function (value) {
        let map_config_values = map_config.map(function (value) {
            return value.name;
        });        
        let headers = {};

        if(type =="mapper"){            
            headers = {
                "transaction": { "label": "Transaction Table Name", "name": "transaction", value:'transaction', type: "html", hide: false, dataType: 'string'},
                "selectAction": { "label": "Action", "name": "selectAction", value:'selectAction', dropdown_value: map_config_values, type: "html", editable: true,  hide: false, dataType: 'string'  },
            };            
            selectedTransactionTable = selectedTransactionTable ? selectedTransactionTable : this.state.selectedTransactionTable
            headers.transaction.label = selectedTransactionTable['name'];
        }

        if(type == "result"){
            headers = {
                "transaction": { "label": "Mapping", "name": "final_table" },
            };
        }
        return Object.values(headers);
    }

   
    // Generate body for HTML table
    generateTableBodyRows__For_HTML(){
     
        let that = this;
        let current_table_selected = this.state.selectedTransactionTable;

        let current_table_selected_columns = current_table_selected.columnConfig;


        let map_dropdown_data = [...that.state.mapOptions];

        var tableRows = current_table_selected_columns.map((element, index) => {
            let rowCells = [];
            let table_name = element['tableValue'].replace(".", "_");
            let id = `${table_name}_${element['value']}`;

            let value = null;

            if (that.state.mapping[that.state.selectedTransactionTable['value']] !== null && that.state.mapping[that.state.selectedTransactionTable['value']] !== undefined) {

                let columnCheck = that.state.mapping[that.state.selectedTransactionTable['value']][element['name']];
                if (columnCheck !== null && columnCheck !== undefined) {
                    value = columnCheck;
                }
            }

            let mapConfig = {
                "class": `my-1`,
                "id": id,
                "placeholder": "Select option to map",
                "size": 5,
                "value": value,
                "dropdownData": map_dropdown_data,
                "width": "auto",
                "valueFlag": true,
            };



            let first_cell = <td key={`${element.label}_${index}_cell`}>{element['name']}</td>;

            let dropdownData = (<MergeDropdownComponent rowIndex={index} dropdownConfig={mapConfig} type="primary_transaction" onChange={that.handleTableMapping} />);

            // let second_cell = <td key={`${element.label}_${index + 1}_cell`}>{'hello'}</td>;
            let second_cell = <td key={`${element.label}_${index + 1}_cell`}>{dropdownData}</td>;
            ;
            rowCells = [first_cell,second_cell];
            return (<tr key={`row_${index}`}>{rowCells}</tr>);
        });

        return <tbody id={`${that.state.selectedTransactionTable.value}_body`}>{tableRows}</tbody>;
    }

    generateTableBodyRows(){
     
        let that = this;
        let current_table_selected = this.state.selectedTransactionTable;

        let current_table_selected_columns = current_table_selected.columnConfig;


        let map_dropdown_data = [...that.state.mapOptions];

        let tableData = [];

        var tableRows = current_table_selected_columns.map((element, index) => {
            let rowCells = []
            let table_name = element['tableValue'].replace(".", "_");
            let id = `${table_name}_${element['value']}`;

            let value = null;

            if (that.state.mapping[that.state.selectedTransactionTable['value']] !== null && that.state.mapping[that.state.selectedTransactionTable['value']] !== undefined) {

                let columnCheck = that.state.mapping[that.state.selectedTransactionTable['value']][element['name']];
                if (columnCheck !== null && columnCheck !== undefined) {
                    value = columnCheck;
                }
            }

            value = value === "new" ? addToFinalTable : value

            let mapConfig = {
                "class": `my-1`,
                "id": id,
                "placeholder": "Select option to map",
                "size": 5,
                "value": value,
                "dropdownData": map_dropdown_data,
                "width": "auto",
                "valueFlag": true,
            };

            rowCells['transaction'] = element['name']
            rowCells['selectAction'] = value
            tableData.push(rowCells)            
        });        
        return { data: tableData };        
    }

    generateFinalBody(){
        let body = [];
        let innerData = [];
        let final_table_state = this.state.final_table;
        if (final_table_state.length === 0){
            innerData = [{ "label": "Final Name", "content": "No Columns added yet" }];
            body.push(innerData);
        } else {
           
            body = final_table_state.map((element,i)=>{
                let initialData = [];
                let tagsBody = [];
                if(element['map'] !== null && element['map'] !== undefined){
                    tagsBody = Object.values(element['map']).map((inner, j) => {
                        let tagConfig = [{
                            "id":`${inner['id']}_${j}`,
                            "text": `${inner[0]['tempSubtext']}.${inner[0]['name']}`
                        }];
                        let tagBody = <TagsComponent readOnly={true} placeholder={""} tags={tagConfig} suggestions={[]} controlState={this.getStateFromChild} />
                        return tagBody;
                    });
                }
              
                let contentTagConfig = [{
                    "id": `${element['id']}_${i}`,
                    "text": `${element['tempSubtext']}.${element['name']}`
                }];
                let contentTag = <div><div className="mg-l-5">{element['name']}</div><TagsComponent readOnly={true} placeholder={""} tags={contentTagConfig} suggestions={[]} controlState={this.getStateFromChild} /></div>

                tagsBody = [contentTag,...tagsBody];

                let initial_array = { "label": "Final Name", "content": tagsBody };
                initialData.push(initial_array);
                return initialData;
            });
        }
        return body;
    }

    render() {        
        // let transaction_table_array = this.props.stepData.fetchIncludedColumns(this.props.stepData.state.selectedTable.transaction);
        // let transaction_table_array = this.props.stepData.fetchIncludedColumns(test_tables);
        var mainData = null;
        var final_data = null;
        var headers = null;

        var otherTransactionDropdown = {
            "class": "my-1",
            "id": "transaction_table",
            "placeholder": "Select transaction table to map",
            "size": 5,
            "value": [],
            "dropdownData": this.state.transaction_table_array,
            "width": "auto",
            "valueFlag": false
        }
    
        if (this.state.selectedTransactionTable.length !== 0){
            // headers = this.generateTableHeader("mapper");
            headers = this.state.headerMapper;

            // For HTML Table - Start
            //     var tableHeaders = headers.map((element, i) => {
            //         return (<th key={`${element.label}_${i}_header`} scope="col">{element.label}</th>);
            //     });
            // let tableBodyRows = this.generateTableBodyRows_old();
            // For HTML Table - End

            let tableBodyRows = this.generateTableBodyRows();
            
            // Below code not in use
            // takes the following array configuration to render 
            // var tableConfig = {
            //     "id": `${this.state.selectedTransactionTable.value}_data`,
            //     "headers": headers,
            //     // "body":body
            // }

            var final_body_config = {
                "id": `${this.state.selectedTransactionTable.value}_mapping_data`,
                "headers":this.state.headerResult,
                "body":this.generateFinalBody()
            };

            // Below line not in use
            // mainData = <BootstrapTable id={tableConfig.id} headers={tableConfig.headers} body={tableConfig.body} />
            let button = {}                       
            mainData = <TableParent                    
                    data={tableBodyRows}
                    parentConfig={this.state}
                    columns_array={headers}                    
                    firstColumnShow={false}                                             
                    onCellChange={this.handleTableMapping}
                    buttonConfig={button}
                    editFlag={1}
                    tableStyle={{marginLeft:"-3%"}}
                />
            // For HTML Table - Start
            // mainData = (<table id={`${this.state.selectedTransactionTable.value}_data`} className="table table-bordered">
            //     <thead className="thead">
            //         <tr>
            //             {tableHeaders}
            //         </tr>
            //     </thead>
            //     {tableBodyRows}
            // </table>);
            // For HTML Table - End

            final_data = <BootstrapTable id={final_body_config.id} headers={final_body_config.headers} body={final_body_config.body} />

        }
        let backButton = { "name": "Back", "event":this.backAction };
        return(
            <>
                <div className="card">
                    <div className="card-header d-flex flex-row justify-content-between">
                        <ButtonComponent buttonData={backButton} />
                        <button className="btn btn-primary btn-sm text-white" id="nextButton" onClick={this.nextAction}>Next</button>
                    </div>
                    <div className="card-body">
                        <div className="col-md-12">
                            <div className="d-flex">
                                <div className="align-items-start mg-t-10">
                                    <span className="tx-spacing-1">Select transaction tables to map</span>
                                    <MergeDropdownComponent dropdownConfig={otherTransactionDropdown} type="transaction_table" onChange={this.handlePrimaryTransaction} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    {mainData}
                                </div>
                                <div className="col-md-6" style={{ marginTop: "1%" }}>
                                    {final_data}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

function mapStateToProps(state) {
    return { tableData: state.admin.tableData };

}


// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({
//         setToolId
//     }, dispatch)
// }

export default connect(mapStateToProps, null)(StepThree);
// export default DataMerge;

